import { render, staticRenderFns } from "./edititem.vue?vue&type=template&id=7d2654d8&"
import script from "./edititem.vue?vue&type=script&lang=ts&"
export * from "./edititem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edititem.vue"
export default component.exports